import React from 'react';
import i18n from '../../utils/i18n';
import TitleInlineEdit from '../forms/TitleInlineEdit';
import {issueAttributesType} from '../../constants/proptype-validation';
import {toLocalLongDate} from '../../utils/date-helpers';
import PropTypes from 'prop-types';
import {viewTypes} from '../../constants/view-types';
import classNames from 'classnames';
import IssueFieldInlineEdit from '../forms/IssueFieldInlineEdit';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import {getCurrentViewType, getUserNameWithCompanyGetter} from '../../app/selectors';
import {connect} from '../../app/connect';

const IssuePreviewDetailsTabTitleSection = ({issue, viewType, getUserDisplayNameWithCompany}) => {
  const {[ISSUE_ATTRIBUTE_NAMES.CREATED_BY]: createdBy, [ISSUE_ATTRIBUTE_NAMES.CREATED_AT]: createdAt} = issue;
  const createdByDisplayNameWithCompanyName = getUserDisplayNameWithCompany(
    createdBy,
    i18n.t('assignment.assigneeDeleted'),
    null
  );

  const formClassNames = classNames('IssuePreviewDetailsTabTitleSection', {
    'IssuePreviewDetailsTabTitleSection--narrow': viewType === viewTypes.DOCUMENT,
    'IssuePreviewDetailsTabTitleSection--wide': viewType === viewTypes.PROJECT
  });
  const inlineEditStyleType =
    viewType === viewTypes.DOCUMENT ? IssueFieldInlineEdit.StyleTypes.SMALL : IssueFieldInlineEdit.StyleTypes.DEFAULT;

  return (
    <form className={formClassNames}>
      {/* Title */}
      <TitleInlineEdit
        issue={issue}
        className="IssuePreviewDetailsTabTitleSection__field"
        styleType={inlineEditStyleType}
      />

      <div
        className="IssuePreviewDetailsTabTitleSection__creation"
        data-testid="IssuePreviewDetailsTabTitleSection__creation"
      >
        <span className="IssuePreviewDetailsTabTitleSection__creation-label">{i18n.t('creation.createdBy')} </span>
        <span
          className="IssuePreviewDetailsTabTitleSection__creation-details"
          data-testid="IssuePreviewDetailsTabTitleSection__creation-details"
        >
          {createdByDisplayNameWithCompanyName}
        </span>
        <span className="IssuePreviewDetailsTabTitleSection__creation-date">
          {` ${i18n.t('creation.on')} ${toLocalLongDate(createdAt)}`}
        </span>
      </div>
    </form>
  );
};

IssuePreviewDetailsTabTitleSection.displayName = 'IssuePreviewDetailsTabTitleSection';

IssuePreviewDetailsTabTitleSection.propTypes = {
  issue: issueAttributesType.isRequired,
  viewType: PropTypes.string.isRequired,
  getUserDisplayNameWithCompany: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  viewType: getCurrentViewType(state),
  getUserDisplayNameWithCompany: getUserNameWithCompanyGetter(state)
});

export default connect(mapStateToProps)(IssuePreviewDetailsTabTitleSection);
